import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMethod } from "../../utils/apiServices";

export const getParkingList = createAsyncThunk(
  "parking/fetchParkingList",
  async () => {
    // setAuthorizationToken(true);
    const response = await getMethod(`/api/parking`);
    return response;
  }
);

const initialState = {
  loading: false,
  success: false,
  error: false,
  parking: null,
};

const parkingSlice = createSlice({
  name: "parking",
  initialState,
  // reducers: {
  //   isLoading: (state) => {
  //     state.loading = true;
  //     state.success = false;
  //     state.error = false;
  //   },
  //   isSuccess: (state, action) => {
  //     state.loading = false;
  //     state.success = true;
  //     state.error = false;
  //     state.parking = action.payload;
  //   },
  //   isError: (state) => {
  //     state.loading = false;
  //     state.success = false;
  //     state.error = true;
  //   },
  // },

  extraReducers: (builder) => {
    builder.addCase(getParkingList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getParkingList.fulfilled, (state, action) => {
      state.loading = false;
      state.parking = action.payload.data;
    });
    builder.addCase(getParkingList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
  },
});

// export const { isLoading, isSuccess, isError } = parkingSlice.actions;

export default parkingSlice.reducer;

// export const getHomeType = () => async (dispatch) => {
//   try {
//     dispatch(isLoading);
//     const response = await getMethod(`/api/homeType`);
//     dispatch(isSuccess(response?.data));
//   } catch (error) {
//     dispatch(isError);
//   }
// };
